import { handleResponseOld, makeGet } from './helpers';

/**
 * @category Item API
 * @see fetchCatalogLocations
 */
type FetchCatalogLocationsParams = {
    deployment: string;
};

/**
 * GET request to item-api service that retrieves catalog location information
 * @function fetchCatalogLocations
 * @category Item API
 * @param {FetchCatalogLocationsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/catalog-locations
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/get-catalog-locations.ts
 */
const fetchCatalogLocations = ({ deployment }: FetchCatalogLocationsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ deployment, path: '<ITEM-API>catalog-locations' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchCatalogLocations,
};
